import { Editor, useEditorState } from '@tiptap/react';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { IconLabel } from '../../../IconLabel';

import classNames from 'classnames';
import classes from '../InlineTools.module.scss';

interface SubscriptProps {
  editor: Editor;
}

export const Subscript: FunctionComponent<SubscriptProps> = ({ editor }) => {
  const { t } = useTranslation();

  const { isActive, canToggle } = useEditorState({
    editor,
    selector: ({ editor }) => ({
      isActive: editor.isActive('subscript'),
      canToggle: editor.can().chain().focus().toggleSubscript().run(),
    }),
  });

  return (
    <IconLabel
      iconId={'subscript'}
      iconSize={16}
      ariaLabel={t('richTextEditor.tool-names-subscript')}
      onClick={() => editor.chain().focus().toggleSubscript().run()}
      disabled={!canToggle}
      className={classNames(classes['inline-tools__item'], {
        [classes['inline-tools__item--active']]: isActive,
        [classes['inline-tools__item--disabled']]: !canToggle,
      })}
    />
  );
};
